import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BrandEmblem } from "./BrandEmblem";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { label: "Executive Overview", target: "#hero" },
  { label: "Stakeholder Pathways", target: "#stakeholder-grid" },
];

export const Header = ({ onOpenAbout, onOpenAuth, onOpenDemo }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollTo = (target) => {
    setMobileOpen(false);
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else navigate("/" + target);
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-[#0B1B2B]/95 backdrop-blur-md border-b border-[#D4AF37]/20 shadow-xl" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[76px] flex items-center justify-between gap-4">
        <button onClick={() => { navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className="flex items-center gap-3 text-left" data-testid="header-brand-link">
          <BrandEmblem />
          <div className="hidden sm:block">
            <div className="font-serif text-lg leading-tight text-white font-semibold tracking-wide">Acuity Rise Education Group LLC</div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-[#D4AF37]">Architecting Reliable Pathways to Clinical Excellence.</div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <button key={n.label} onClick={() => scrollTo(n.target)} className="gold-underline text-white/90 hover:text-white font-sans text-sm tracking-wide transition-colors" data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {n.label}
            </button>
          ))}
          <button onClick={onOpenAbout} className="gold-underline text-white/90 hover:text-white font-sans text-sm tracking-wide transition-colors" data-testid="nav-about">
            About Us
          </button>
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <button onClick={() => navigate("/dashboard")} className="text-sm font-semibold text-[#D4AF37] gold-underline" data-testid="header-dashboard-button">
                Dashboard
              </button>
              <button onClick={() => { logout(); navigate("/"); }} className="text-sm text-white/70 hover:text-white transition-colors" data-testid="header-logout-button">
                Sign Out
              </button>
            </>
          ) : (
            <button onClick={onOpenAuth} className="text-sm text-white/90 hover:text-white font-medium px-4 py-2 rounded-xl border border-white/20 hover:border-[#D4AF37]/60 transition-colors" data-testid="header-login-button">
              Portal Login
            </button>
          )}
          <button onClick={onOpenDemo} className="bg-[#D4AF37] text-[#0B1B2B] text-sm font-semibold px-5 py-2.5 rounded-xl hover:bg-[#e8c968] transition-all duration-300 hover:shadow-lg" data-testid="header-begin-intake-button">
            Request Demo Access
          </button>
        </div>

        <button className="lg:hidden text-white p-2" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-[#0B1B2B] border-t border-[#D4AF37]/20 px-6 py-6 space-y-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <button key={n.label} onClick={() => scrollTo(n.target)} className="block text-white/90 text-sm w-full text-left">
              {n.label}
            </button>
          ))}
          <button onClick={() => { setMobileOpen(false); onOpenAbout(); }} className="block text-white/90 text-sm w-full text-left">About Us</button>
          {user ? (
            <button onClick={() => { setMobileOpen(false); navigate("/dashboard"); }} className="block text-[#D4AF37] text-sm font-semibold w-full text-left">Dashboard</button>
          ) : (
            <button onClick={() => { setMobileOpen(false); onOpenAuth(); }} className="block text-[#D4AF37] text-sm font-semibold w-full text-left" data-testid="mobile-login-button">Portal Login</button>
          )}
        </div>
      )}
    </header>
  );
};
